export const LOAD_ASSET: 'LOAD_ASSET' = 'LOAD_ASSET';
export const LOAD_ASSET_SUCCESS: 'LOAD_ASSET_SUCCESS' = 'LOAD_ASSET_SUCCESS';
